import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import exportFromJSON from 'export-from-json';
import { Button } from 'react-bootstrap';
import DataTablePagination from '../Pagination/DataTablePagination';

const Export = ({ data }) => {
  const fileName = "user-data";

  const exportCSV = () => {
    const exportType = exportFromJSON.types.csv;
    exportFromJSON({ data, fileName, exportType });
  };

  const exportExcel = () => {
    const exportType = exportFromJSON.types.xls;
    exportFromJSON({ data, fileName, exportType });
  };

  return (
    <div className="export-options d-flex align-items-center me-2">
      <div className="export-title small me-2">Export</div>
      <div className="btn-group">
        <Button variant="outline-light" onClick={() => exportCSV()}>
          CSV
        </Button>
        <Button variant="outline-light" onClick={() => exportExcel()}>
          Excel
        </Button>
      </div>
    </div>
  );
};

const expandedComponent = ({ data }) => (
  <ul className="data-details p-3 gap gy-1 border-bottom small">
    <li>
      <span className="data-title text-base fw-medium me-2">Name:</span>
      <span className="data-text text-light">{data.name}</span>
    </li>
    <li>
      <span className="data-title text-base fw-medium me-2">Age:</span>
      <span className="data-text text-light">{data.age}</span>
    </li>
    <li>
      <span className="data-title text-base fw-medium me-2">Position:</span>
      <span className="data-text text-light">{data.position}</span>
    </li>
    <li>
      <span className="data-title text-base fw-medium me-2">Company:</span>
      <span className="data-text text-light">{data.company}</span>
    </li>
    <li>
      <span className="data-title text-base fw-medium me-2">Start Date:</span>
      <span className="data-text text-light">{data.startDate}</span>
    </li>
    <li>
      <span className="data-title text-base fw-medium me-2">Salary:</span>
      <span className="data-text text-light">{data.salary}</span>
    </li>
  </ul>
);

const customCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => (
  <div className="form-check" id={rest.name}>
    <input
      type="checkbox"
      className="form-check-input"
      ref={ref}
      onClick={onClick}
      {...rest}
    />
  </div>
));

function DataTableComponent({ data, columns, className, expandableRows, actions, tableClassName, selectableRows, searchTerm, searchList, drill = '', totalCount, page, rowsPerPage, onChangePage, onChangeRowsPerPage, onSearchTextChange, ...props }) {
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [ mobileView, setMobileView ] = useState(false);
  

  useEffect(() => {
    setTableData(data);
  }, [data]);


  const inputStyle = {
    width: `${(searchTerm.length + 10) * 10}px`,
  };

  const viewChange = () => {
    if (window.innerWidth < 960 && expandableRows) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  };

  useEffect(() => {
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
    };
  }, []); 

  return (
    <div className="data-table-wrapper">
      <div className="data-table-top">
        <div className="data-table-search">
          <input
            className="form-control"
            placeholder={`Search by ${searchTerm}`}
            type="text"
            style={inputStyle}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value); 
              if (onSearchTextChange) { onSearchTextChange(e.target.value); }
            }}  
          />
        </div>
        <div className="data-table-action-wrap">
          {actions && <Export data={data} />}
          <div className="data-table-select">
            <select
              className="form-select"
              onChange={(e) => onChangeRowsPerPage({ target: { value: parseInt(e.target.value, 10) } })}
              value={rowsPerPage}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="25">25</option>
            </select>
            <span className="text">Per page</span>
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={tableData}
        className={tableClassName}
        noDataComponent={tableData.length === 0 ? <div className="p-2">There are no records found.</div> : null}
        sortIcon={<div className="data-table-sorter"></div>}
        expandableRowsComponent={expandedComponent}
        expandableRows={mobileView}
        selectableRows={selectableRows}
        selectableRowsComponent={customCheckbox}
      />
      <div className="data-table-bottom">
        <DataTablePagination
          count={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default DataTableComponent;
